<template>
  <div class="animated fadeIn">
    <h1>Non ci sono promemoria</h1>
  </div>
</template>

<script>


export default {
  name: 'avvisi',
  mixins: [window.myMixin],
  components: {
  },
  data: function () {
    return {
    }
  },
  computed:{

},
  methods: {
  }
}
</script>

<style>

</style>
